'use client';

import { QUERY_FORWARD_ROUTE } from '@/lib/constants';
import { HttpLink } from '@apollo/client';
import {
  ApolloClient,
  ApolloNextAppProvider,
  InMemoryCache,
} from '@apollo/experimental-nextjs-app-support';
import React from 'react';
import { cacheConfig } from './cache';

const makeClient = () =>
  new ApolloClient({
    cache: new InMemoryCache(cacheConfig),
    link: new HttpLink({
      uri: QUERY_FORWARD_ROUTE,
      credentials: 'same-origin',
    }),
  });

export const ApolloWrapper = ({ children }: React.PropsWithChildren) => (
  <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>
);
